import React from "react";
import styled from "@emotion/styled";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import Card from "../common/card";
import { useTheme } from "../../contexts/ThemeContext";
import { useLanguage } from "../../contexts/LanguageContext";
import { Theme } from "../../theme";

// Styled Components - 参照される順に定義
const WorkImage = styled.img`
	width: 52px;
	height: 52px;
	border-radius: 0.75rem;
	object-fit: cover;
	margin-bottom: 0;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
	transition: all 0.3s ease;
`;

const WorkTitle = styled.div<{ theme: Theme }>`
	color: ${props => props.theme.colors.text.primary};
	font-size: 1rem;
	font-weight: 700;
	margin-bottom: 0.25rem;
`;

const WorkSubtitle = styled.div<{ theme: Theme }>`
	color: ${props => props.theme.colors.text.secondary};
	font-size: 0.95rem;
	font-weight: 500;
	margin-bottom: 0.25rem;
`;

const WorkDuration = styled.div<{ theme: Theme }>`
	color: ${props => props.theme.colors.text.tertiary};
	font-size: 0.875rem;
	font-weight: 400;
`;

const Work = styled.div<{ theme: Theme }>`
	display: flex;
	flex-direction: row;
	align-items: center;
	text-align: left;
	gap: 0.75rem;
	padding: 0;
	background: transparent;
	transition: all 0.3s ease;

	&:hover {
		${WorkImage} {
			transform: scale(1.1);
			box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
		}
	}
`;

const WorksBody = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
`;

const WorkDetails = styled.div`
	min-width: 0;
`;

const Works: React.FC = () => {
	const { theme } = useTheme();
	const { t } = useLanguage();

	return (
		<Card
			icon={faBriefcase}
			title={t.homepage.work.title}
			body={
				<WorksBody>
					<Work theme={theme}>
						<WorkImage
							src="https://s3-symbol-logo.tradingview.com/cyber-agent--600.png"
							alt="CyberAgent"
						/>
						<WorkDetails>
							<WorkTitle theme={theme}>{t.homepage.work.company}</WorkTitle>
							<WorkSubtitle theme={theme}>{t.homepage.work.position}</WorkSubtitle>
							<WorkDuration theme={theme}>{t.homepage.work.duration}</WorkDuration>
						</WorkDetails>
					</Work>
				</WorksBody>
			}
		/>
	);
};

export default Works;
